import { CEMessageAttributesBase } from './ce-message-attributes-base'


export class CEMessageAttributes extends CEMessageAttributesBase {

}